export const FallbackRefCode = ["jDro6zP6cM", undefined] as const satisfies readonly [string, string | undefined];

export const RefCodeMap: {
  [key: string]: [string] | [string, string];
} = {};
